import { render, staticRenderFns } from "./featherIcon.vue?vue&type=template&id=df2f1314&"
import script from "./featherIcon.vue?vue&type=script&lang=js&"
export * from "./featherIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports